import React from 'react'
import styled from 'styled-components'
import { isMobile } from './../../../../helpers/window.helper'
import Browser from '.././../../../services/Browser'
import { breakpoints } from '../../../../constants'
import { LIGHTBLUE, BLUE, PRIMARY_LIGHT } from '../../../../styles/colors.style'

const FIRST = 1
const SECOND = 2
const THIRD = 3

const PriceOptionComponent = ({
	price,
	hasValue,
	hasPoints,
	hasPlusSign,
	onPriceSelected,
	pricesLength,
	isPublicBody,
	isRequester,
}) => {
	let position = THIRD
	if (hasPoints && hasValue) position = SECOND
	if (hasValue && !hasPlusSign) position = FIRST

	const showPromotionValue =
		!isPublicBody &&
		!isRequester &&
		position == FIRST &&
		price.valueToShow !== price.value

	const valueToShow =
		isPublicBody || isRequester ? price.value : +price.valueToShow

	return (
		<StyledContainerPrice position={position} isMobile={isMobile()}>
			<StyledPrice
				pricesLength={pricesLength}
				style={{ order: position }}
				className={`price-${position}`}
				hasPlusSign={hasPlusSign}
				onClick={() => onPriceSelected(price)}>
				{hasPoints && (
					<span>
						{`${price.pointsToShow.toLocaleString('pt-BR')} pts`}&nbsp;
					</span>
				)}
				{hasValue && (
					<span className={`only-reais-${!hasPlusSign}`}>
						{showPromotionValue ? (
							<React.Fragment>
								<div
									style={{
										textDecoration: 'line-through',
										fontSize: '1.1rem',
										fontWeight: 'normal',
									}}>
									De: {price.value.$toReais()}
								</div>
								<div>Por: {(+price.valueToShow).$toReais()}</div>
							</React.Fragment>
						) : (
							<span>
								{hasPlusSign && ' + '} {valueToShow.$toReais()}
							</span>
						)}
					</span>
				)}
			</StyledPrice>
			{position === FIRST && !hasPoints && !isPublicBody ? (
				<div className="prices-footer">
					<span className="payment-info">Pague em até 12x!</span>
				</div>
			) : (
				<div />
			)}
		</StyledContainerPrice>
	)
}

const StyledContainerPrice = styled.div`
	display: flex;
	${(props) =>
		!props.isMobile
			? props.position === SECOND
				? 'flex: 1.6'
				: 'flex: 1'
			: ''};
	flex-direction: column-reverse;
	justify-content: center;
	align-items: center;
	justify-content: flex-end;
`

const StyledPrice = styled.div`
	background: white;
	border: 1px solid ${BLUE};
	border-radius: 5px;
	color: ${BLUE};
	cursor: pointer;
	display: flex;
	font-size: 14px;
	flex-direction: column;
	line-height: 12px;
	padding: 2px 5px;
	text-align: center;
	font-weight: bold;
	${(props) => props.className === 'price-2' && `flex-direction: row;`}
	height: 45px;
	justify-content: center;
	align-items: center;

	&.selected {
		background: ${BLUE};
		color: white;
	}

	&:hover {
		background: ${LIGHTBLUE};
		color: white;
	}

	${(props) =>
		props.className === 'price-1' &&
		`
			background: ${PRIMARY_LIGHT};
			border-color: ${PRIMARY_LIGHT};
			color: white;
		`}

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		display: flex;
		font-size: small;
		justify-content: center;
		line-height: 13px;
		margin-top: initial;
		max-height: 35px;
		min-height: initial;
		width: 100%;
		${(props) => props.className === 'price-2' && `line-height: 3;`}

		${({ hasPlusSign }) =>
			hasPlusSign
				? ''
				: `
			align-items: center;
		`}

		${Browser.isEdge() ? 'margin-left: 10px; margin-right: 10px;' : ''}
	}

	@media screen and (max-width: ${breakpoints.PHONE_LARGE}px) {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 40px;
		line-height: 17px;
		padding: 0px 5px;
		text-align: center;
		align-items: center;
		justify-content: center;
		margin-right: 5px;
		font-size: 1.8rem;
		margin-top: 5px;

		&:first-child {
			margin-right: 0;
		}
	}

	@media screen and (min-width: 375px) {
		width: ${({ pricesLength }) => (pricesLength > 1 ? '100%' : '30%')};
		min-height: 45px;
		min-width: 100px;
	}
`

export default PriceOptionComponent
